import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';
import './services/http';


const theme = extendTheme({
  fonts: {
    heading: 'Inter, sans-serif',
    body: 'Inter, sans-serif',
  },
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((reg) => console.log('SW registered', reg))
    .catch(err => console.error('SW reg failed', err));
}


ReactDOM.createRoot(document.getElementById('root')!).render(
<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "484158409702-ls0nbb067s5eimmpsm08anqc3mtoovb6.apps.googleusercontent.com"}>
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
</GoogleOAuthProvider>

);
